module.exports = __webpack_public_path__ + "static/media/276-pom7736-jj@3x.0fca8afa.png";